export default [
  {
    path: '/',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/home');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/faq',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/faq');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/checkout-agreement',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/checkout-agreement');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/user-agreement',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/user-agreement');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/splash',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/decision');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/decision',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/decision');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
  {
    path: '/personnel-data-protection',
    async(routeTo, routeFrom, resolve, reject) {
      const reactComponent = () => import('./pages/personnel-data-protection');
      reactComponent().then(rc => {
        resolve({ component: rc.default });
      });
    },
  },
];
